module.exports = __webpack_public_path__ + "img/Iraq.55dfc84e.svg";